import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { UpdateSmallBusinessApplicationApiRequest } from '@/application/smallBusiness/infrastructure/types/UpdateSmallBusinessApplicationApiRequest';

export class UpdateApplicationApiAdapter {

  public static async entityToApiRequest (application: SmallBusinessApplication): Promise<UpdateSmallBusinessApplicationApiRequest> {
    return {
      applicants: application.applicants,
      plans: application.plans,
      contribution: application.contribution,
      appointment: application.appointment,
      effective_date: application.effective_date,
      filters: application.filters,
      sample_employee: application.sample_employee,
      detailed_employees: application.detailed_employees,
      company: application.company,
      uuid: application.uuid,
      referenceGroupId: application.referenceGroupId
    };
  }

}
